import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyList"] */ "/app/src/components/new/PrivacyPolicyList/PrivacyPolicyList.tsx");
